import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

/**
 * Thousands-grouped, pinned to `en` rather than the runtime locale.
 *
 * A bare `toLocaleString()` renders 20000 as "20.000" on a de-DE browser, which reads as twenty. Pinning
 * it also stops one number wearing two spellings across a page: the audience size bar and the count badge
 * state the same figure, and a locale-dependent formatter had them disagree on the same screen.
 */
const GROUPED = new Intl.NumberFormat('en');

/** A whole number with thousands separators — "20,000". See {@link GROUPED} for the pinned locale. */
export function formatGrouped(value: number): string {
  return GROUPED.format(value);
}

export function formatJson(value: unknown): string {
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}

/** Human-friendly relative time string (e.g. "5 minutes ago"). */
export function timeAgo(dateStr: string): string {
  return dayjs(dateStr).fromNow();
}

/**
 * Format a date string for list pages.
 * Relative for recent (< 7 days), absolute for older.
 */
export function formatDate(dateStr: string): string {
  const d = dayjs(dateStr);
  if (dayjs().diff(d, 'day') < 7) return d.fromNow();
  return d.format('MMM D, YYYY');
}

/** Full datetime for title tooltips, including the viewer's timezone offset. */
export function formatDateTimeTitle(date: string): string {
  return dayjs(date).format('MMMM D, YYYY [at] h:mm A [GMT]Z');
}
